export function maskDateBr(date: string) {
  const stripped = date.replace(/\D/g, '').slice(0, 8);

  if (stripped.length < 3) {
    return stripped
  } else if (stripped.length < 5) {
    return stripped.replace(/(\d{1,2})(\d{0,2})/g, '$1/$2')
  }

  return stripped.replace(/(\d{1,2})(\d{0,2})(\d{0,4})/g, '$1/$2/$3')
}